import { render } from "./EventDetail.vue?vue&type=template&id=3f474276&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"

import "./EventDetail.vue?vue&type=style&index=0&id=3f474276&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f474276"]])

export default __exports__